import React, { useContext } from 'react';

import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

const CircuitCountSetter: React.FC = () => {
  let { chillerLog, setChillerLog } = useContext(ChillerLogsContext);

  const handleCircuitCountChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const newCount = Number(event.target.value);
    setChillerLog({ ...chillerLog, circuit_count: newCount });
  };

  return (
    <Grid item xs={3} style={{ marginTop: 20, marginLeft: 0 }}>
      <TextField
        select
        label="Circuit Count"
        value={chillerLog?.circuit_count || 1}
        onChange={handleCircuitCountChange}
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        fullWidth
        style={{ marginLeft: -30, marginTop: 20 }}
      >
        {[1, 2, 3, 4].map((count) => (
          <MenuItem key={count} value={count}>
            {count}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
  );
};

export default CircuitCountSetter;
